import React from 'react';
import { ADD_MAKE_MODEL_STATUS } from '../constants';

const getMakeModel = (
  makeName,
  modelName,
  chassisMakeName,
  chassisModelName,
) => {
  const bodyMM = `${makeName} ${modelName}`;
  if (!chassisMakeName || !chassisModelName) return bodyMM;
  return `${bodyMM} / ${chassisMakeName} ${chassisModelName}`;
};

// Maps a make/model action to its past-tense and gerund forms for toasts.
const ACTION_VERBS = {
  Approve: { past: 'approved', gerund: 'approving' },
  Reject: { past: 'rejected', gerund: 'rejecting' },
  Add: { past: 'added', gerund: 'adding' },
};

export const getMakeModelSuccessMessage = (
  action,
  makeName,
  modelName,
  chassisMakeName,
  chassisModelName,
) => {
  const verb = (ACTION_VERBS[action] || ACTION_VERBS.Reject).past;
  return (
    <>
      You have successfully {verb}{' '}
      <b>
        {getMakeModel(makeName, modelName, chassisMakeName, chassisModelName)}
      </b>
      .
    </>
  );
};

export const getMakeModelErrorMessage = (
  errMsg,
  action,
  makeName,
  modelName,
  chassisMakeName,
  chassisModelName,
) => {
  const mm = getMakeModel(
    makeName,
    modelName,
    chassisMakeName,
    chassisModelName,
  );
  if (!errMsg?.startsWith('OPEN_LINES_ERROR:')) {
    const verb = (ACTION_VERBS[action] || ACTION_VERBS.Reject).gerund;
    return (
      <>
        There was an error while {verb} <b>{mm}</b>.
      </>
    );
  }

  const openLines = JSON.parse(errMsg.replace('OPEN_LINES_ERROR:', ''));
  return (
    <>
      The selected make and model <b>{mm}</b> is associated with the below
      active contract line(s) and cannot be Rejected. The lines should be closed
      or updated with a different make and model to continue.
      {openLines.map((line) => (
        <li key={line.id}>
          Contract <b>{line.contractNumber}</b> line <b>{line.scheduleLine}</b>
        </li>
      ))}
    </>
  );
};

// Translates an addMakeModelByEngineer result status into an Alert descriptor.
// SUCCESS -> green success toast; the ALREADY_* statuses are non-fatal and
// surface as a yellow warning that names the offending make and model.
export const getAddMakeModelToast = (status, makeName, modelName) => {
  const mm = `${makeName} - ${modelName}`;

  if (status === ADD_MAKE_MODEL_STATUS.ALREADY_EXISTS) {
    return {
      type: 'warning',
      message: (
        <>
          The make and model already exists. <b>{mm}</b>
        </>
      ),
    };
  }

  if (status === ADD_MAKE_MODEL_STATUS.ALREADY_SUBMITTED) {
    return {
      type: 'warning',
      message: (
        <>
          The make and model has already been submitted for approval.{' '}
          <b>{mm}</b>
        </>
      ),
    };
  }

  return {
    type: 'success',
    message: getMakeModelSuccessMessage('Add', makeName, modelName),
  };
};
